/* eslint array-callback-return: 0 */
/* eslint no-unneeded-ternary: 0 */
/* eslint max-len: 0 */
import {
    AppIntegrationsRepository,
    TransactionsRepository,
    LicensesRepository,
    ActivationCodesRepository,
    RecommendationsRepository,
    FlexiblePromotionsRepository,
    UsersRepository,
    PaymentTypesRepository,
} from 'common/repositories/index';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';
import log from 'common/services/logging/loggers';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import { DevicesProcessor, ActivationCodesProcessor, ExpiredLicensesProcessor } from 'common/repositoryProcessors/index';

const currentDeviceOS = window.deviceOs;

let _licenseRestService;
let _activationCodeRestService;
let _activationCodesRepository;
let _RecommendationsRestService;
let _devicesProcessor;
let _licensesRepository;
let _flexiblePromotionsRepository;
let _util;
let _$scope;
let _$state;
let _$translate;
let _$window;
let _$timeout;
let _activationCodesProcessor;
let _expiredLicensesProcessor;
let _expiringActivationCodes;
let _expiringLicenses;
let _transactionRestService;
let _$rootScope;
let _UsersRepository;
let _sessionAddPaymentTooltips = {};
let _paymentTypes;

const _serviceDependencies = ['$scope', '$state', '$window', '$timeout', '$location', '$anchorScroll',
    '$rootScope', '$translate', 'ActivationCodeRestService', 'Util',
    'LicenseRestService', 'RecommendationsRestService', 'TransactionRestService'];

/**
 * @ngdoc service
 * @name controllers.Subscriptions
 *
 * @description
 * Subscriptions controller
 */
class Subscriptions {

    constructor(
        $scope, $state, $window, $timeout, $location, $anchorScroll,
        $rootScope, $translate,
        ActivationCodeRestService, Util, LicenseRestService, RecommendationsRestService,
        TransactionRestService,
    ) {

        _licenseRestService = LicenseRestService;
        _activationCodesRepository = ActivationCodesRepository;
        _activationCodeRestService = ActivationCodeRestService;
        _RecommendationsRestService = RecommendationsRestService;
        _licensesRepository = LicensesRepository;
        _devicesProcessor = DevicesProcessor;
        _activationCodesProcessor = ActivationCodesProcessor;
        _transactionRestService = TransactionRestService;
        _UsersRepository = UsersRepository;
        _flexiblePromotionsRepository = FlexiblePromotionsRepository;
        _expiredLicensesProcessor = ExpiredLicensesProcessor;
        _paymentTypes = PaymentTypesRepository.getAll();

        _util = Util;

        _$scope = $scope;
        _$rootScope = $rootScope;
        _$translate = $translate;
        _$state = $state;

        _$window = $window;
        _$timeout = $timeout;

        _$scope.appIntegrations = {};

        _$scope.activationStatus = '';
        _$scope.licenses = {};
        _$scope.finalStepActivationWizard = false;
        _$scope.isStaticOTC = false;
        _$scope.inputActivationCode = '';
        _$scope.loadingButton = false;
        _$scope.bannerButtonLoading = false;
        _$scope.brandName = CWCONFIG.partnerConfig.name;
        _$scope.primeAppIds = CWCONFIG.primeAppIds || [];

        _$scope.paymentTypes = PaymentTypesRepository.getAll();

        $scope.onTabClick = (tabName) => {

            Mixpanel.send(`ConnectWeb ${tabName} Tab Click`);

        };

        if (_$rootScope.scrollToExpiredSubscriptions) {

            $location.hash('expired-subscriptions-anchor');
            $anchorScroll();

        }

        const currentLanguage = CWCONFIG.language;
        const configSupportLanguages = CWCONFIG.cma.subscriptions.supportLanguages;
        let redirectSupportLanguage = '';

        if (configSupportLanguages.find(lang => lang === currentLanguage)) {

            if (currentLanguage === 'en') {

                redirectSupportLanguage = 'en-us';

            } else {

                redirectSupportLanguage = currentLanguage;

            }

        } else {

            redirectSupportLanguage = 'en-us';

        }

        _$scope.cancellationPolicy = CWCONFIG.cma.subscriptions.tooltip.cancellationPolicy.replace(/\[language\]/gi, currentLanguage);
        _$scope.contactUs = CWCONFIG.cma.subscriptions.tooltip.contactUs.replace(/\[language\]/gi, redirectSupportLanguage);
        _$scope.mobileAppInfoLink = CWCONFIG.cma.subscriptions.mobileAppInfoLink.replace(/\[language\]/gi, redirectSupportLanguage);

        // AV Pro campaign - save campaign query params to localstorage
        const extraUrlParams = JSON.parse(sessionStorage.getItem('SsoExtraUrlParams'));

        if (extraUrlParams && extraUrlParams.campaign) {

            localStorage.setItem('offerAutoSubscription', extraUrlParams.campaign);

        }

        // Check if agent id (aid) exists and has a numeric value on session storage
        if (sessionStorage.getItem('aid') && !Number.isNaN(parseInt(sessionStorage.getItem('aid'), 0))) {

            // Show the otc tab for support agents only
            _$scope.showOTCTab = true;

        }

        // session storage obj
        _sessionAddPaymentTooltips = JSON.parse(sessionStorage.getItem('staticOTCs')) || {};

        // This object is used to display the discount tooltip
        _$rootScope.promotionsTooltips = {};

        // Hide the prepaid subscription toggle for US and CA users
        // TBD in the future
        const users = _UsersRepository.getAll();
        const userCountry = _util.deepFind(users[0], 'attributes.country');
        _$scope.checkUserCountryForPrepaid = (activatioCode) => {

            if (activatioCode.attributes.subscription_type !== 'prepaid') {

                return true;

            }

            return userCountry !== 'US' && userCountry !== 'CA';

        };

        _$scope.AppIntegrationsRepository = AppIntegrationsRepository;

        // Filter all the transactions that have the price 0
        _$scope.transactions = TransactionsRepository.getAll()
            .filter((transaction) => {

                if (transaction.attributes.price) {

                    const formatPrice = transaction.attributes.price.replace(',', '');

                    return Number(formatPrice) > 0;

                }

                return false;

            });

        // Format each transaction date
        _$scope.transactions.forEach((transaction) => {

            const dateCreate = _util.deepFind(transaction, 'attributes.date_create');
            transaction.attributes.formatted_date_create = moment(dateCreate).format('L');

        });

        _$scope.refreshRequests = 0;
        _$scope.deviceOs = Util.getDeviceNavigator();
        _$scope.isBusinessProduct = this.isBusinessProduct;
        _$scope.getDateDifference = this.getDateDifference;
        _$scope.isMobilePurchase = this.isMobilePurchase;
        _$scope.isVoucherPurchase = this.isVoucherPurchase;
        _$scope.isUsComplied = this.isUsComplied;
        _$scope.successAnimation = false;
        _$scope.currentTab = _$state.params.tab || 'plans';


        Mixpanel.send('ConnectWeb Subscriptions Open', {
            Source: 'Direct',
            Tab: _$scope.currentTab,
            Section: _$rootScope.activeNavSection === 'renewal' ? 'Renewal Settings' : 'Subscriptions',
        });

        this.activationCodeLength = 29;
        this.currentDateInMiliseconds = new Date().getTime();

        _$scope.isPrimeOfferActive = Util.deepFind(CWCONFIG, 'features.offerBanner.showOffer');

        this.subjectActivationCodes = _activationCodesProcessor.getObservable();
        this.activationCodesSubscriber = this.subjectActivationCodes
            .subscribe(
                data => this.onActivationCodesNext(data),
                () => { },
                () => { },
            );

        this.activationCodesSubscriber = this.subjectActivationCodes
            .subscribe(
                data => this.onFlexiblePromotionsNext(data),
                () => { },
                () => { },
            );

        this.licensesRepository = _licensesRepository.getObservable();
        this.licensesSubscriber = this.licensesRepository
            .subscribe(
                data => this.onLicensesNext(data),
                () => { },
                () => { },
            );

        this.subjectFlexiblePromotions = _flexiblePromotionsRepository.getObservable();
        this.flexiblePromotionsSubscriber = this.subjectFlexiblePromotions
            .subscribe(
                data => this.onFlexiblePromotionsNext(data),
                () => { },
                () => { },
            );

        this.expiredLicensesProcessor = _expiredLicensesProcessor.getObservable();
        this.expiredLicensesSubscriber = this.expiredLicensesProcessor
            .subscribe(
                data => this.onExpiredLicensesNext(data),
                () => { },
                () => { },
            );

        $rootScope.showCmaDisclaimer.withdrawalConsent = !!$rootScope.euWithdrawalConsentEligible && _$scope.currentTab === 'plans';

        _$scope.$on('$destroy', () => {

            this.activationCodesSubscriber.dispose();
            this.licensesSubscriber.dispose();
            this.expiredLicensesSubscriber.dispose();
            $rootScope.activeNavSection = '';
            $rootScope.scrollToExpiredSubscriptions = false;
            $rootScope.showCmaDisclaimer.withdrawalConsent = false;

        });

        // open subscription history tab if is detected in $rootScope.urlHash
        if ($rootScope.urlHash === 'history') {

            $rootScope.urlHash = '';

            _$state.go('root.dashboard.subscriptions', {
                tab: 'history',
            });

        }

        // redirect to "plans" tab if there are no transactions on history page
        if (_$scope.currentTab === 'history' && _$scope.transactions.length === 0) {

            _$state.go('root.dashboard.subscriptions', {
                tab: 'plans',
            });

        }

        if (_$scope.finalStepActivationWizard === true ||
            _$scope.activationCodes.length !== 0 ||
            _$scope.userTrialLicenses.length !== 0 ||
            !_$rootScope.hasUsCompliance) {

            _$rootScope.showCmaDisclaimer.banner = false;

        }

        if ((_$scope.firstexpiringLicense && !_$scope.firstexpiringLicense.attributes.customInfo.isNonrenewableApp && !_$scope.firstexpiringLicense.attributes.has_partner_id
            && !_$scope.userHaveActivePrime && !_$scope.firstexpiringLicense.attributes.customInfo.hideTrialExpiringNotification && !_$scope.firstexpiringLicense.isCardDeleted && _$rootScope.hasUsCompliance)) {

            if (_$scope.firstexpiringLicense.isStaticOTC === false &&
                _$scope.firstexpiringLicense.attributes.type !== 'eval') {

                _$rootScope.showCmaDisclaimer.banner = false;

            } else {

                _$rootScope.showCmaDisclaimer.banner = true;

            }

        }

    }

    /**
     * Replace all licenses with received data
     * @param {Array} data
     */
    onLicensesNext(data) {

        _expiringLicenses = [];

        _$scope.userTrialLicenses = data.filter(license => _util.deepFind(license, 'attributes.type') === 'eval');

        // hide trial expiring notification for other licenses if we have an prime in trials list
        const primeTrials = _$scope.userTrialLicenses
            .filter(license => _$scope.primeAppIds.indexOf(license.relationships.app.data.id) > -1);
        const hasPrimeTrial = primeTrials.length > 0;

        _$scope.userTrialLicenses.forEach((license) => {

            const appId = _util.deepFind(license, 'relationships.app.data.id');

            const expirationDate = _util.deepFind(license, 'attributes.date_expire');
            const dateExpiring = _util.deepFind(license, 'attributes.expiration_date');
            license.attributes.customInfo = {};
            license.attributes.customInfo.hideTrialExpiringNotification = hasPrimeTrial && _$scope.primeAppIds.indexOf(appId) === -1;
            const expireNotificationDays = this.getExpireNotificationDays(license);

            license.attributes.customInfo.formatted_expiration_date = moment(dateExpiring).format('L');

            if (appId && !_$scope.appIntegrations[appId]) {

                _$scope.appIntegrations[appId] = AppIntegrationsRepository.getById(appId) || {};
                _$scope.appIntegrations[appId].appComponents = [];

                const includedApps = _util.deepFind(_$scope.appIntegrations[appId], 'relationships.apps') || {};

                const hiddenAppInBundleIds = CWCONFIG.hiddenAppInBundle || [];

                if (includedApps.data) {

                    includedApps.data.forEach((app) => {

                        if (!hiddenAppInBundleIds.find(id => app.id === id) && AppIntegrationsRepository.getById(app.id) !== undefined) {

                            _$scope.appIntegrations[appId].appComponents.push(AppIntegrationsRepository.getById(app.id));

                        }

                    });

                }

            }

            // add the remaining days until subscription expires in activation code object - custom info
            if (expirationDate) {

                const remainingDaysUntilExpiration = this.getDateDifference(expirationDate);

                license.attributes.customInfo.remainingDaysUntilExpiration = remainingDaysUntilExpiration;
                license.attributes.customInfo.showExpirationNotification = false;

                if (remainingDaysUntilExpiration <= expireNotificationDays &&
                    license.attributes.subscription === 0 &&
                    license.attributes.app.indexOf('aib0') === -1) {

                    license.attributes.customInfo.showExpirationNotification = true;

                } else {

                    license.attributes.customInfo.showExpirationNotification = false;

                }

            }

            if (dateExpiring) {

                const remainingDaysUntilExpiration = this.getDateDifference(dateExpiring);

                license.attributes.customInfo.remainingDaysUntilExpiration = remainingDaysUntilExpiration;
                license.attributes.customInfo.showExpirationNotification = false;

                if (remainingDaysUntilExpiration <= expireNotificationDays) {

                    license.attributes.customInfo.showExpirationNotification = true;

                    const found = _expiringLicenses.find(element => element.id === license.id);

                    if (!found) {

                        _expiringLicenses.push(license);

                    }

                } else {

                    license.attributes.customInfo.showExpirationNotification = false;

                }

            }

            this.returnFirstExpirationDate();
            license.attributes.customInfo.devices = _devicesProcessor.getDevicesByLicenseId(license.id);

        });

    }

    /**
     * Replace all events with received data
     * @param {Array} data
     */
    onActivationCodesNext(data) {

        _$scope.activationCodes = data;
        // dont show expiring banner for other subscriptions. (show banner only if auto-renewal for Prime is OFF)
        _$scope.userHaveActivePrime = ActivationCodesRepository.hasActivePrime();

        // Hide the ocp banner if the user already has prime
        // const hasPrime = _$scope.activationCodes
        //    .find(activationCode => (activationCode.attributes.app === 'aps10' || activationCode.attributes.app === 'aps20'));
        // $scope.hideRecommendationBanner = !!(hasPrime);

        _expiringActivationCodes = [];
        const allTransactions = TransactionsRepository.getAll();

        _$scope.activationCodes.forEach((activationCode) => {

            const appId = _util.deepFind(activationCode, 'relationships.app.data.id');
            const expirationDate = _util.deepFind(activationCode, 'attributes.date_expire');
            let nextBillingEvent = _util.deepFind(activationCode, 'attributes.next_billing_event');
            const subscriptionType = _util.deepFind(activationCode, 'attributes.subscription_type');
            activationCode.attributes.customInfo = {};
            const isNonrenewableApp = _util.isNonrenewableApp(appId);

            if (subscriptionType === 'yearly' || subscriptionType === 'annual' || subscriptionType === 'annual-trial') {

                activationCode.attributes.customInfo.showAnnual = true;

            } else if (subscriptionType === 'monthly' || subscriptionType === 'monthly-trial') {

                activationCode.attributes.customInfo.showMonthly = true;

            }

            if (isNonrenewableApp) {

                activationCode.attributes.customInfo.isNonrenewableApp = true;

            }

            if (!nextBillingEvent) {

                switch (subscriptionType) {

                case 'yearly':
                    nextBillingEvent = moment(expirationDate).subtract(35, 'days');
                    break;
                case 'monthly':
                    nextBillingEvent = moment(expirationDate).subtract(5, 'days');
                    break;
                case 'annual':
                    nextBillingEvent = moment(expirationDate).subtract(35, 'days');
                    break;
                case 'monthly-trial':
                    nextBillingEvent = moment(expirationDate).subtract(1, 'days');
                    break;
                case 'annual-trial':
                    nextBillingEvent = moment(expirationDate).subtract(1, 'days');
                    break;
                default:
                    nextBillingEvent = expirationDate;

                }

            }

            // get purchase date
            const activationCodePurchaseDate = allTransactions.find(transaction =>
                transaction.attributes.activation_code === activationCode.id);
            const paymentGateway = _util.deepFind(activationCodePurchaseDate, 'attributes.payment_gateway');

            if (subscriptionType === 'annual' && (paymentGateway === 'CB' || paymentGateway === 'CA')) {

                const nextBillingEventTimeStamp = new Date(expirationDate).getTime();

                const startDate1 = new Date('2022-04-03').getTime();
                const endDate1 = new Date('2022-04-10').getTime();

                const startDate2 = new Date('2022-04-11').getTime();
                const endDate2 = new Date('2022-04-18').getTime();

                const startDate3 = new Date('2022-04-19').getTime();
                const endDate3 = new Date('2022-04-26T00:00:00Z').getTime();

                const startDate4 = new Date('2022-04-27').getTime();
                const endDate4 = new Date('2022-05-02').getTime();

                if (nextBillingEventTimeStamp >= startDate1 && nextBillingEventTimeStamp <= endDate1) {

                    activationCode.attributes.customInfo.formatted_next_billing_event = moment(new Date('2022-03-21')).format('L');

                } else if (nextBillingEventTimeStamp >= startDate2 && nextBillingEventTimeStamp <= endDate2) {

                    activationCode.attributes.customInfo.formatted_next_billing_event = moment(new Date('2022-03-22')).format('L');

                } else if (nextBillingEventTimeStamp >= startDate3 && nextBillingEventTimeStamp <= endDate3) {

                    activationCode.attributes.customInfo.formatted_next_billing_event = moment(new Date('2022-03-23')).format('L');

                } else if (nextBillingEventTimeStamp >= startDate4 && nextBillingEventTimeStamp <= endDate4) {

                    activationCode.attributes.customInfo.formatted_next_billing_event = moment(new Date('2022-03-28')).format('L');

                } else {

                    activationCode.attributes.customInfo.formatted_next_billing_event = moment(nextBillingEvent).format('L');

                }

            } else {

                activationCode.attributes.customInfo.formatted_next_billing_event = moment(nextBillingEvent).format('L');

            }

            activationCode.attributes.customBillingDateForCMA = activationCode.attributes.customInfo.formatted_next_billing_event;

            activationCode.attributes.customInfo.formatted_date_expire = moment(expirationDate).format('L');

            // get transaction id from filtered transactions (hide transaction id for transactions with price 0)
            const activationCodeTransactionId = _$scope.transactions.find(transaction =>
                transaction.attributes.activation_code === activationCode.id);

            // Check if the payment type associated with the current activation code was removed
            // Get transaction id associated with the current activation code
            const paymentTransactionId = _util.deepFind(activationCodeTransactionId, 'attributes.payment_transaction_id');

            // Get payment type details based on the transaction id
            const paymentTypeDetails = _paymentTypes.find(payment => payment.id === paymentTransactionId);

            // If the card was removed, so we need to disable the auto-renewal toggle
            if (_util.isPaymentCardDeleted(paymentTypeDetails)) {

                activationCode.removedPaymentOption = true;

            }

            if (activationCodePurchaseDate) {

                activationCode.attributes.customInfo.purchaseDate = _util.deepFind(activationCodePurchaseDate, 'attributes.date_create');
                activationCode.attributes.customInfo.transactionId = _util.deepFind(activationCodeTransactionId, 'attributes.payment_transaction_id');
                const purchaseDate = _util.deepFind(activationCodePurchaseDate, 'attributes.date_create');

                activationCode.attributes.customInfo.purchaseDate = moment(purchaseDate).format('L');

            } else {

                let runtime = _util.deepFind(activationCode, 'attributes.runtime');
                let runtimeUnit = _util.deepFind(activationCode, 'attributes.runtime_unit');

                if (runtime === 1 && runtimeUnit === 'months') {

                    runtime = 30;
                    runtimeUnit = 'days';

                } else if (subscriptionType === 'annual-trial') {

                    runtimeUnit = 'trial-days';

                }

                // convert runtime date to ms
                let activationDate = new Date(expirationDate);
                if (runtimeUnit === 'days') {

                    activationDate = activationDate.setDate(activationDate.getDate() - runtime);

                } else if (runtimeUnit === 'months') {

                    activationDate = activationDate.setMonth(new Date(expirationDate).getMonth() - runtime);

                } else if (runtimeUnit === 'trial-days') {

                    const license = _licensesRepository.getLicenseBy(activationCode.id);
                    const creationDate = _util.deepFind(license, 'attributes.creation_date');
                    activationDate = new Date(creationDate);

                }

                activationCode.attributes.customInfo.purchaseDate = moment(activationDate).format('L');

            }


            const expireNotificationDays = this.getExpireNotificationDays(activationCode);

            if (appId && !_$scope.appIntegrations[appId]) {

                _$scope.appIntegrations[appId] = AppIntegrationsRepository.getById(appId) || {};
                _$scope.appIntegrations[appId].appComponents = [];

                const includedApps = _util.deepFind(_$scope.appIntegrations[appId], 'relationships.apps') || {};

                const hiddenAppInBundleIds = CWCONFIG.hiddenAppInBundle || [];

                if (includedApps.data) {

                    includedApps.data.forEach((app) => {

                        if (!hiddenAppInBundleIds.find(id => app.id === id) && AppIntegrationsRepository.getById(app.id) !== undefined) {

                            _$scope.appIntegrations[appId].appComponents.push(AppIntegrationsRepository.getById(app.id));

                        }

                    });

                }

            }

            _$scope.licenses[activationCode.id] =
                _licensesRepository.getLicenseBy(activationCode.id);

            // add the remaining days until subscription expires in activation code object - custom info
            if (expirationDate) {

                const todayFormatted = moment().format('L');
                const expirationDateFormatted = moment(expirationDate).format('L');

                const remainingDaysUntilExpiration = this.getDateDifference(expirationDate);

                activationCode.attributes.customInfo.remainingDaysUntilExpiration = remainingDaysUntilExpiration;
                activationCode.attributes.customInfo.showExpirationNotification = false;

                if (this.checkStaticOTC(activationCode)) {

                    activationCode.attributes.customInfo.expiringToday = false;

                } else {

                    activationCode.attributes.customInfo.expiringToday = !!(todayFormatted === expirationDateFormatted);

                }

                if (remainingDaysUntilExpiration <= expireNotificationDays &&
                    activationCode.attributes.subscription === 0 &&
                    !activationCode.attributes.customInfo.isNonrenewableApp) {

                    activationCode.attributes.customInfo.showExpirationNotification = true;

                    const found = _expiringActivationCodes.find(element => element.id === activationCode.id);

                    if (!found) {

                        _expiringActivationCodes.push(activationCode);

                    }

                } else {

                    activationCode.attributes.customInfo.showExpirationNotification = false;

                }

            }

            const license = LicensesRepository.getLicenseBy(activationCode.id) || {};
            activationCode.attributes.customInfo.devices = _devicesProcessor.getDevicesByLicenseId(license.id);
            this.returnFirstExpirationDate();

            this.setSessionStorageStaticOTCs(activationCode);

            _$scope.switchedToMonthlyTooltips = JSON.parse(sessionStorage.getItem('switchedToMonthlyTooltips'));

        });

        this.filterActivatonCodes(_$scope.activationCodes);

        setTimeout(() => {

            _$scope.$apply();

        }, 1000);

    }

    /**
     * Replace all expired licenses with received data
     * @param {Array} data
     */
    onExpiredLicensesNext(data) {

        _$scope.expiredLicenses = data;

        if (_$scope.expiredLicenses.length > 0) {

            // Show the Expired Licenses tab
            _$scope.showExpiredLicensesTab = true;

            _$scope.expiredLicenses.forEach((license) => {

                const appId = _util.deepFind(license, 'relationships.app.data.id');
                const activationCode = _util.deepFind(license, 'relationships.activation-code.data.id');
                const expirationDate = _util.deepFind(license, 'attributes.expiration_date');

                license.attributes.formatted_expiration_date = moment(expirationDate).format('L');

                if (appId && !_$scope.appIntegrations[appId]) {

                    _$scope.appIntegrations[appId] = AppIntegrationsRepository.getById(appId) || {};
                    _$scope.appIntegrations[appId].appComponents = [];

                    const includedApps = _util.deepFind(_$scope.appIntegrations[appId], 'relationships.apps') || {};

                    const hiddenAppInBundleIds = CWCONFIG.hiddenAppInBundle || [];

                    if (includedApps.data) {

                        includedApps.data.forEach((app) => {

                            if (!hiddenAppInBundleIds.find(id => app.id === id) && AppIntegrationsRepository.getById(app.id) !== undefined) {

                                _$scope.appIntegrations[appId].appComponents.push(AppIntegrationsRepository.getById(app.id));

                            }

                        });

                    }

                }

                // get transaction id only for regular subscriptions
                if (license.attributes.subscription_type !== 'prepaid') {

                    _$scope.transactions.forEach((transaction) => {

                        if ((transaction.attributes.activation_code === activationCode) &&
                        (transaction.attributes.app === license.relationships.app.data.id)) {

                            license.attributes.transactionId = transaction.attributes.payment_transaction_id;

                        }

                    });

                }

            });

        }

    }

    // return the number of days to notify users that their subscription will expire
    // param {obj} activationCode || license
    getExpireNotificationDays(data) {

        const monthlyExpireNotificationDays = CWCONFIG.monthlySubscriptionExpirationReminderDays || 20;
        const annualExpireNotificationDays = CWCONFIG.annualSubscriptionExpirationReminderDays || 60;
        const annualSubscriptionTypes = ['annual', 'annual-trial', 'yearly'];
        let isAnnualSubscription = false;

        if (annualSubscriptionTypes.indexOf(data.attributes.subscription_type) > -1) {

            if ((data.attributes.type === 'eval') &&
                ((data.attributes.runtime_unit === 'months' && data.attributes.runtime <= 1) ||
                    (data.attributes.runtime_unit === 'days' && data.attributes.runtime <= 30))) {

                isAnnualSubscription = false;

            } else {

                isAnnualSubscription = true;

            }

        }

        return isAnnualSubscription ? annualExpireNotificationDays : monthlyExpireNotificationDays;

    }

    onFlexiblePromotionsNext() {

        const flexiblePromotions = _flexiblePromotionsRepository.getAll() || [];

        flexiblePromotions.forEach((promotion) => {

            _$scope.activationCodes.forEach((activationCode) => {

                if (promotion.id === activationCode.attributes.promotion_id) {

                    activationCode.attributes.promotion = {};
                    activationCode.attributes.promotion = promotion;

                }

            });

        });

    }

    /**
     * Returns the difference in days until the expiration
     * @param {Date} date
     */
    timeUntilExpiration(license) {

        const duration = this.getDateDifference(license.attributes.expiration_date);

        if (duration === 1 && license.attributes.expired === false) {

            return _$translate.instant('cw.subscription.day', { interval: duration });

        }
        if (duration > 1 && license.attributes.expired === false) {

            return _$translate.instant('cw.subscription.days', { interval: duration });

        }
        if (duration < 0 && license.attributes.expired === true) {

            return _$translate.instant('cw.subscription.expired');

        }
        return '';

    }

    /**
     * Compares received date string with the current date
     * Returns the difference in days as int
     * If the diffrence is less than a day, always returns 1 day.
     * @param {String} date
     */
    getDateDifference(date) {

        const startTime = moment();
        const endTime = moment(date);
        const difference = parseInt(moment.duration(endTime.diff(startTime)).asDays(), 10) + 1;

        return difference;

    }

    // filter activations that are not properly configured and print them in console
    filterActivatonCodes(activationCodes) {

        const hiddenActivationCodes = [];

        activationCodes.forEach((activationCode) => {

            const appId = _util.deepFind(activationCode, 'relationships.app.data.id');
            const appCorrespondingToActivation = AppIntegrationsRepository.getById(appId);
            const canBeShown = appCorrespondingToActivation &&
                _util.deepFind(appCorrespondingToActivation, 'attributes.custom.manifest.name') &&
                _util.deepFind(appCorrespondingToActivation, 'attributes.custom.manifest.os') ?
                true :
                false;
            if (!canBeShown) {

                // if the app is missing from appIntegration resource, we log only the appId
                hiddenActivationCodes.push(appCorrespondingToActivation || appId);

                Mixpanel.send('ConnectWeb Subscription App Error', {
                    appId,
                });

            }

        });

        if (hiddenActivationCodes.length > 0) {

            log.log({
                type: 'Product Catalog - subscriptions that don\'t meet the criteria to be visible',
                cmd: 'show hiddenActivationCodes',
                data: hiddenActivationCodes,
            });

        }

    }

    // check if OTC is static
    checkStaticOTC(activationCode) {

        return (activationCode.attributes.subscription === 0 &&
            (
                activationCode.attributes.subscription_type === 'yearly' ||
                activationCode.attributes.subscription_type === 'prepaid'
            )
        );

    }

    isBusinessProduct(activationCode) {

        const { businessProducts } = CWCONFIG.store || [];
        return !!(businessProducts.find(app => activationCode.attributes.app === app));

    }

    activateSubscription(activationCodeId) {

        const activationCode = _activationCodesRepository.getById(activationCodeId);
        const appId = _util.deepFind(activationCode, 'relationships.app.data.id') || 'New OTC';
        const appIntegration = AppIntegrationsRepository.getById(appId);

        _$scope.appName = _util.deepFind(appIntegration, 'attributes.resource.oeName') || 'New OTC';

        Mixpanel.send('ConnectWeb My Subscriptions Activate Click', {
            Product: _$scope.appName,
            'Product ID': appId,
        });

        if (this.activationCodeLength !== activationCodeId.length) {

            _util.triggerAnimation('.error', 'animated shake');
            _$scope.activationStatus = 'error';
            return;

        }

        _$scope.loadingButton = true;

        const licensePayload = {
            data: {
                type: 'licenses',
                relationships: {
                    'activation-code': {
                        data: { type: 'activation-codes', id: activationCodeId },
                    },
                    provider: {
                        data: { type: 'providers', id: _$window.appName },
                    },
                },
            },
        };

        _licenseRestService
            .create(licensePayload)
            .then((response) => {

                const licenseAppId = _util.deepFind(response, 'data.data.relationships.app.data.id');
                const licenseAppIntegration = AppIntegrationsRepository.getById(licenseAppId);
                _$scope.appName = _util.deepFind(licenseAppIntegration, 'attributes.resource.oeName');

                Mixpanel.send('ConnectWeb My Subscriptions Activate Success', {
                    Product: _$scope.appName,
                    'Product ID': appId,
                });

                if (_$scope.activationCodes.length === 0) {

                    _$scope.finalStepActivationWizard = true;

                    // detect static OTC
                    _$scope.isStaticOTC = this.checkStaticOTC(response.data.data);

                } else {

                    _$scope.successAnimation = true;
                    _$scope.inputActivationCode = '';

                }

                _$scope.activationStatus = 'success';
                _$scope.loadingButton = false;

                _$timeout(() => {

                    this.fetchActivationCodes();

                }, 2500);

            })
            .then(null, (error) => {

                const errorCode =
                    (error.data.errors && error.data.errors[0]) ? error.data.errors[0].code : false;

                _$scope.activationStatus = 'serverError';
                _$scope.serverErrorTranslate = '';
                _$scope.loadingButton = false;

                Mixpanel.send('ConnectWeb My Subscriptions Activate Error', {
                    Product: _$scope.appName,
                    'Product ID': appId,
                    'Error Code': errorCode,
                });

                switch (errorCode) {

                case '21224': // activation code was not found

                    _util.triggerAnimation('.error', 'animated shake');
                    _$scope.serverErrorTranslate = 'cw.subscription.error.status_code_not_found';
                    break;

                case '21223': // activation code invalid
                case '21246': // code not found in database

                    _util.triggerAnimation('.error', 'animated shake');
                    _$scope.serverErrorTranslate = 'cw.subscription.error.status_code_invalid';
                    break;

                case '21236': // activation code already used

                    _util.triggerAnimation('.error', 'animated shake');
                    _$scope.serverErrorTranslate = 'cw.subscription.error.status_code_already_used';
                    break;

                case '21225': // activation code expired

                    _util.triggerAnimation('.error', 'animated shake');
                    _$scope.serverErrorTranslate = 'cw.subscription.error.status_code_expired';
                    break;

                case '21241': // maximum users for activation code

                    _util.triggerAnimation('.error', 'animated shake');
                    _$scope.serverErrorTranslate = 'cw.subscription.error.max_users_reached';
                    break;

                default:

                    Alert.error('cw.notification.system.error');
                    _$scope.serverErrorTranslate = undefined;

                }

            });

    }

    fetchActivationCodes() {

        _activationCodeRestService
            .getAllAsync()
            .then((response) => {

                _activationCodesRepository.replace(response.data.data);
                _$scope.successAnimation = false;

                /**
                 * Get recommendations will be empty, observable in recommendations banner
                 * will be triggered and hide the banner
                 */
                _RecommendationsRestService.getAllAsync().then((res) => {

                    RecommendationsRepository.replace(res.data.data);

                });

                if (_$scope.finalStepActivationWizard === false) {

                    _$state.go('root.dashboard.subscriptions', {
                        tab: 'plans',
                    });

                }

            })
            .then(null, () => {

                Alert.error();
                _$scope.successAnimation = false;

            });

    }

    subscriptionToggle(activationCode, label) {

        const newToggleState = activationCode.attributes.subscription !== 0 ? 'Off' : 'On';

        if (newToggleState === 'Off') {

            const runtime = this.getDateDifference(activationCode.attributes.date_expire);

            Mixpanel.send(`ConnectWeb Subscription ${newToggleState} Click`, {
                Page: 'Subscriptions',
                Product:
                    _$scope.appIntegrations[activationCode.relationships.app.data.id].attributes.resource.oeName,
                'Product ID': activationCode.relationships.app.data.id,
                'Current Runtime': runtime,
                'Subscription Runtime': activationCode.attributes.runtime,
                'Subscription Type': activationCode.attributes.subscription_type,
            });

        }

        if (newToggleState === 'On') {

            const runtime = this.getDateDifference(activationCode.attributes.date_expire);

            Mixpanel.send(`ConnectWeb Subscription ${newToggleState} Click`, {
                Page: 'Subscriptions',
                Product:
                    _$scope.appIntegrations[activationCode.relationships.app.data.id].attributes.resource.oeName,
                'Product ID': activationCode.relationships.app.data.id,
                'Current Runtime': runtime,
                'Subscription Runtime': activationCode.attributes.runtime,
                'Subscription Type': activationCode.attributes.subscription_type,
                Label: label ? label : '',

            });

        }

        if (this.checkStaticOTC(activationCode) &&
            activationCode.attributes.add_payment_details_link) {

            this.onRenewalClick(activationCode, 'OTC');

        } else {

            const allTransactions = TransactionsRepository.getAll();
            const transaction = allTransactions.find(el => el.attributes.activation_code === activationCode.id);
            if (transaction) {

                _$rootScope.dateABTest = transaction.attributes.date_create;

            }
            _$state.go('root.dashboard.subscriptions.ltb', {
                ltb: 'confirm',
                resourceId: activationCode.id,
            }, {
                reload: false,
            });

        }

    }

    onRenewalClick(activationCode, type, campaign) {

        const mixPanelPayload = {
            Page: 'Subscriptions',
            Label: 'Activation Codes List',
            Type: type,
            Product:
                _$scope.appIntegrations[activationCode.relationships.app.data.id].attributes.resource.oeName,
            'Campaign Name': campaign ? activationCode.attributes.cmp : 'None',
        };

        Mixpanel.send('ConnectWeb Renew Click', mixPanelPayload);

        const appId = _util.deepFind(activationCode, 'relationships.app.data.id');
        const isIframeProduct =
            CWCONFIG.subscriptions.iframeProducts.find(product => product === appId);

        if (isIframeProduct && campaign !== 'cobi2020avpro') {

            const licenseId = activationCode.type === 'licenses' ? activationCode.id : _licensesRepository.getLicenseBy(activationCode.id).id;

            _$state.go('root.dashboard.subscriptions.ltb.renew', {
                ltb: 'payment-cart',
                resourceId: appId,
                subsource: 'renew',
                licenseId,
            }, {
                reload: false,
            });

        }

        _$scope.renewLink = isIframeProduct ? '' : `${_util.deepFind(activationCode, 'attributes.renewal_link')}&x-a-source=cw`;

    }


    getButtonAction(resource) {

        if (resource.type === 'licenses') {

            const license = resource;

            const isWebApp = !!(this.isWebApp(license.relationships.app.data.id));

            if (isWebApp) {

                return 'open';

            }

            return 'install';

        } else if (resource.type === 'activation-codes') {

            const activationCode = resource;

            const readyToInstall = !!(activationCode.attributes.status === 'used' &&
                _util.deepFind(_$scope.appIntegrations[activationCode.relationships.app.data.id], 'attributes.custom.manifest.os') &&
                _$scope.licenses[activationCode.id]);

            const readyToActivate = !!(activationCode.attributes.status !== 'used');

            const isWebApp = !!(this.isWebApp(activationCode.relationships.app.data.id));

            if (isWebApp) {

                return 'open';

            } else if (readyToInstall) {

                return 'install';

            } else if (readyToActivate) {

                return 'activate';

            }

        }

        return '';

    }

    isWebApp(app) {

        const appData = AppIntegrationsRepository.getById(app);

        if (!appData) {

            return false;

        }

        const platformList = _util.deepFind(appData, 'attributes.platform.type') ||
            _util.deepFind(appData, 'attributes.custom.manifest.os'); // fallback option;

        if (!platformList) {

            return false;

        }

        const isWebApp = platformList.indexOf('webapp') !== -1;

        if (isWebApp) {

            return true;

        }

        return false;

    }

    showService(app, subscriptionId, currentTab, campaignName, installType) {

        let stateName = _$state.current.name;

        Mixpanel.send('ConnectWeb Install Click', {
            Page: 'Subscriptions',
            Product: _$scope.appIntegrations[app].attributes.resource.oeName,
            'Product ID': app,
            'Campaign Name': campaignName ? campaignName : 'None',
            Label: installType || 'install',
        });

        if (stateName.indexOf('.ltb.deploy') === -1) {

            stateName += '.ltb.deploy';

        }

        // hide ocp tooltip
        _$rootScope.ocpSubscriptionTooltipAppId = null;

        const isWebApp = this.isWebApp(app);

        if (isWebApp) {

            // open modal for redirecting to webapp url
            _$state.go(stateName, {
                ltb: 'deploy',
                resourceId: subscriptionId,
                deviceId: 'new',
                appId: app,
                os: 'webapp',
                tabs: currentTab,
                licenseId: '',
            }, {
                reload: false,
            });

        } else {


            const matchingOS = _devicesProcessor.getDeployOSfor(app, currentDeviceOS) || null;

            const hasMatchingOS = !!matchingOS;

            if (installType === 'other_device') {

                _$state.go(stateName, {
                    ltb: 'deploy',
                    resourceId: subscriptionId,
                    deviceId: 'new',
                    appId: app,
                    tabs: currentTab,
                    licenseId: '',
                }, {
                    reload: false,
                });

            } else {

                const appToInstall = app;
                const autoInstallValue = hasMatchingOS;

                _$state.go(stateName, {
                    ltb: 'deploy',
                    resourceId: subscriptionId,
                    deviceId: 'new',
                    appId: appToInstall,
                    os: matchingOS,
                    tabs: currentTab,
                    licenseId: '',
                    autoInstall: autoInstallValue,
                }, {
                    reload: false,
                });

            }

        }

    }

    closeActivationWizard() {

        _$scope.finalStepActivationWizard = false;
        _$scope.inputActivationCode = '';
        _$state.go('root.dashboard.subscriptions', {
            tab: 'plans',
        });

    }

    goToStore(mixpanelValue) {

        Mixpanel.send(mixpanelValue);
        _$state.go('root.dashboard.store');

    }

    resetActivationStatus() {

        _$scope.activationStatus = '';

    }

    activateCode(activationCode) {

        _$state.go('root.dashboard.subscriptions.ltb', {
            ltb: 'activation-confirmation',
            resourceId: activationCode.id,
        });

    }

    /**
     * If appId is found in appsForDevices, the copy in view will be forced to be 'devices'
     */
    hardcodeDeviceLicenseType(appId) {

        const appsForDevices = ['aapd0', 'aapd5', 'ispm0', 'isec0', 'asu60', 'atss0', 'aapl0', 'swoe0', 'ao001', 'aps10', 'aps20'];

        if (appsForDevices.indexOf(appId) > -1) {

            return true;

        }

        return false;

    }

    /**
     * If appId is found in apps, the copy in view will have a harcoded number of devices
     */
    hardcodeDevicesNumber(appId) {

        const apps = ['aps10', 'aps20'];

        const appsDevices = {
            aps10: {
                devices: 5,
            },
            aps20: {
                devices: 25,
            },
        };

        if (apps.indexOf(appId) > -1) {

            return appsDevices[appId].devices;

        }

        return false;

    }

    returnFirstExpirationDate() {

        const expiring = [];
        _$scope.firstexpiringLicense = '';

        if (_expiringActivationCodes) {

            _expiringActivationCodes.forEach((activationCode) => {

                expiring.push(activationCode);

            });

        }

        if (_expiringLicenses) {

            _expiringLicenses.forEach((license) => {

                expiring.push(license);


            });

        }

        if (expiring.length > 1) {

            // first expiring will be only Prime if we have an Prime license/activation code
            const expiringPrimeLicense = expiring.filter(license => _$scope.primeAppIds.indexOf(license.relationships.app.data.id) > -1);
            let firstExpiring;
            if (expiringPrimeLicense.length > 0) {

                firstExpiring = expiringPrimeLicense.reduce((previous, current) => ((
                    previous.attributes.customInfo.remainingDaysUntilExpiration <
                    current.attributes.customInfo.remainingDaysUntilExpiration) ? previous : current));

            } else {

                firstExpiring = expiring.reduce((previous, current) => ((
                    previous.attributes.customInfo.remainingDaysUntilExpiration <
                    current.attributes.customInfo.remainingDaysUntilExpiration) ? previous : current));

            }

            _$scope.firstexpiringLicense = firstExpiring;

        } else if (expiring.length === 1) {

            [_$scope.firstexpiringLicense] = expiring;

        }

        if (_$scope.firstexpiringLicense) {

            if (this.checkStaticOTC(_$scope.firstexpiringLicense)) {

                _$scope.firstexpiringLicense.isStaticOTC = true;

            } else {

                _$scope.firstexpiringLicense.isStaticOTC = false;

            }

        }

    }

    activateFirstExpiringLicense(activationCode, type) {

        if (this.isVoucherPurchase(activationCode)) {

            this.firstExpiringLicenseEvent(activationCode, type);

            Mixpanel.send('ConnectWeb Auto Renew Click', {
                Page: 'Subscriptions',
                Label: 'Banner',
                Type: type,
                Product:
                    _$scope.appIntegrations[activationCode.relationships.app.data.id].attributes.resource.oeName,
            });

        } else {

            _$scope.bannerButtonLoading = true;
            const key = activationCode.id || '';

            const payloadActivationCode = {
                data: {
                    attributes: {
                        subscription: '1',
                    },
                    relationships: {
                        provider: {
                            data: {
                                type: 'providers',
                                id: _$window.appName,
                            },
                        },
                    },
                },
            };

            _activationCodeRestService
                .updateAsync(key, payloadActivationCode)
                .then((response) => {

                    _activationCodesRepository.update(response.data.data);
                    _$scope.bannerButtonLoading = false;

                    Mixpanel.send('ConnectWeb Auto Renew Click', {
                        Page: 'Subscriptions',
                        Label: 'Banner',
                        Type: type,
                        Product:
                            _$scope.appIntegrations[activationCode.relationships.app.data.id].attributes.resource.oeName,
                    });

                })
                .then(null, (error) => {

                    const responseError =
                        (
                            error.data &&
                            error.data.errors &&
                            error.data.errors[0]
                        ) ? error.data.errors[0].code : false;

                    _$scope.bannerButtonLoading = false;

                    switch (responseError) {

                    case '21312':
                        Alert.error('cw.subscription.error.no-payment');
                        break;

                    case '21313':
                        Alert.error('cw.subscription.error.status_no_change_appstore');
                        break;

                    case '21315':
                        Alert.error('cw.subscription.error.no-payment');
                        break;

                    case '21316':
                        Alert.error('cw.subscription.error.status_no_change_google_play');
                        break;

                    case '21317':
                        Alert.error('cw.subscription.error.status_no_change_google_play');
                        break;

                    default:
                        Alert.error('cw.notification.system.error');

                    }

                });

        }

    }

    refreshTransactions() {

        _$scope.refreshLoader = true;

        _transactionRestService.getAllAsync().then((response) => {

            TransactionsRepository.replace(response.data.data);

            _$scope.transactions = TransactionsRepository.getAll();

            // Format each transaction date
            _$scope.transactions.forEach((transaction) => {

                const dateCreate = _util.deepFind(transaction, 'attributes.date_create');
                transaction.attributes.formatted_date_create = moment(dateCreate).format('L');

            });

            _$scope.refreshLoader = false;
            _$scope.refreshRequests += 1;

            Alert.success();

        }).catch(() => {

            _$scope.refreshRequests += 1;
            Alert.error();

        });

    }

    firstExpiringLicenseEvent(license, type) {

        Mixpanel.send('ConnectWeb Renew Click', {
            Page: 'Subscriptions',
            Label: 'Banner',
            Type: type,
            Product:
                _$scope.appIntegrations[license.relationships.app.data.id].attributes.resource.oeName,
        });

        const appId = _util.deepFind(license, 'relationships.app.data.id');
        const isIframeProduct =
            CWCONFIG.subscriptions.iframeProducts.find(product => product === appId);

        if (isIframeProduct) {

            const licenseId = license.type === 'licenses' ? license.id : _licensesRepository.getLicenseBy(license.id).id;
            _$state.go('root.dashboard.subscriptions.ltb.renew', {
                ltb: 'payment-cart',
                resourceId: appId,
                subsource: 'renew',
                licenseId,
            }, {
                reload: false,
            });

        }
        _$scope.renewLinkBanner = isIframeProduct ? '' : `${_util.deepFind(license, 'attributes.renewal_link')}&x-a-source=cw`;

    }

    setSessionStorageStaticOTCs(activationCode) {

        // for each static OTC a new key is added in staticOTC obj from session storage
        if (this.checkStaticOTC(activationCode) && activationCode.attributes.add_payment_details_link) {

            if (_sessionAddPaymentTooltips[activationCode.id] === undefined || _sessionAddPaymentTooltips[activationCode.id] === null) {

                _sessionAddPaymentTooltips[activationCode.id] = true;

            }

        }

        _$scope.showAddPaymentTooltips = _sessionAddPaymentTooltips;
        sessionStorage.setItem('staticOTCs', JSON.stringify(_sessionAddPaymentTooltips));

    }

    // close the tooltip for the current session
    closeActivationTooltip(activationCode) {

        if (_sessionAddPaymentTooltips[activationCode.id]) {

            _sessionAddPaymentTooltips[activationCode.id] = false;

        }

        _$scope.showAddPaymentTooltips = _sessionAddPaymentTooltips;
        sessionStorage.setItem('staticOTCs', JSON.stringify(_sessionAddPaymentTooltips));

    }

    sendMixpanelEventDetailsButton(activationCode, label) {

        Mixpanel.send('ConnectWeb Subscription Details Click', {
            Page: 'Subscriptions',
            Label: label,
            Product:
                _$scope.appIntegrations[activationCode.relationships.app.data.id].attributes.resource.oeName,
        });

    }

    sendMixpanelEventEnableSubscription(activationCode, label, action) {

        Mixpanel.send('ConnectWeb Subscription Short View Click', {
            Page: 'Subscriptions',
            'Button Label': label,
            Action: action,
            Product:
                _$scope.appIntegrations[activationCode.relationships.app.data.id].attributes.resource.oeName,
            'Subscription Runtime': activationCode.attributes.runtime,
            'Subscription Type': activationCode.attributes.subscription_type,
        });

    }

    sendMixpanelEventEnableSubscriptionDiscountBanner() {

        Mixpanel.send('ConnectWeb Banner Discount Auto-Renew Click');

    }

    // check if this was purchased from Google or Apple
    isMobilePurchase(activateCode) {

        const tranzactions = TransactionsRepository.getAll().find(transaction => transaction.attributes.activation_code === activateCode.id);
        const paymentGateway = tranzactions ? tranzactions.attributes.payment_gateway : undefined;

        if (paymentGateway === 'GOOG') {

            _$scope.paymentGateway = 'Google';
            return true;

        } else if (paymentGateway === 'AAPL') {

            _$scope.paymentGateway = 'Apple';
            return true;

        }

        return false;

    }

    // check if this was purchased by family and friend voucher so we will hide autorenew toogle and enable subscription button
    isVoucherPurchase(activateCode) {

        const transactionWithVoucher = TransactionsRepository.getAll().find(transaction => transaction.attributes.activation_code === activateCode.id);

        if (transactionWithVoucher && transactionWithVoucher.attributes) {

            return transactionWithVoucher.attributes.payment_type === 'Voucher' ? true : false;

        }

        return false;

    }

    // check if the user has US compliance - the subscription can only be turned off
    isUsComplied(activationCode) {

        if (activationCode.attributes.subscription === 0 && !_$rootScope.hasUsCompliance) {

            return false;

        }

        return true;

    }

    sendMixpanelEventAIAPrimeDetails() {

        Mixpanel.send('ConnectWeb AIA Prime Details Click');

    }

}

_serviceDependencies.push(Subscriptions);

angular.module('controllers')
    .controller('Subscriptions', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/dashboard/body/content/subscriptions/subscriptions.js